import { CSSProperties } from 'react';

const styles = {
    containerStyle: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'stretch',
        flexGrow: 1,
        minWidth: 0,
    } as CSSProperties,
    dashboardContainerStyle: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'start',
        flexGrow: 1,
        minHeight: 0,
        overflow: 'hidden',
    } as CSSProperties,
};

export default styles;
